module.exports = __webpack_public_path__ + "static/beats-poster-5cc88715e5bbc8a0524da153b3f7f846.jpg";